module.exports = __webpack_public_path__ + "static/demolition-chimney_removal-798167c0e2fb3c281144e164e20a9494.png";